<bn-loading-overlay></bn-loading-overlay>

<div class="alert alert-info" *ngIf="msgSemResultado">
    Não foram encontrados limites para o Agente Financeiro selecionado.
</div>

<div *ngIf="limites && limites.length">
    <div class="d-flex justify-content-end">
        <button [disabled]="limites.length == 0" class="btn btn-secondary m-0" type="button"
          (click)="btnExportarLista()" placement="top"
          ngbTooltip="Exporta todos os limites listados">
          <i class="fa fa-file"></i> Exportar limites de exposição</button>
      </div>
    <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
    <div class="table-responsive">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th>Agente Financeiro</th>
                    <th class="titulo-moeda">Limite exposição</th>
                    <th class="titulo-moeda">Exposição atual</th>
                    <th *ngIf="!ehFGBS" class="text-end" container="body" ngbTooltip="Valor exposto pelo AF no Portal FGI (sistema legado)">Exposição Legado</th>
                    <th class="titulo-moeda" [ngbTooltip]="tipValorDisponivel" container="body">Valor disponível</th>
                <tr>
            </thead>
            <tbody>
                <tr *ngFor="let limite of limites">
                    <td>
                        {{limite.nomeAgente}}
                    </td>
                    <td *ngIf="!temMensagem(limite)" [ngClass]="'moeda'">
                        {{ limite?.valorLimite || 0 | bnMask:'MOEDA' }}
                    </td>
                    <td *ngIf="temMensagem(limite)" class="text-end text-danger">
                        {{ limite?.mensagem }}
                    </td>
                    <td [ngClass]="'moeda'">
                        {{ limite?.valorExposicaoAtual || 0 | bnMask:'MOEDA' }}
                    </td>
                    <td *ngIf="!ehFGBS" [ngClass]="'moeda'">
                        {{ limite?.valorLimiteLegado || 0 | bnMask:'MOEDA' }}
                    </td>
                    <td *ngIf="!temMensagem(limite)" [ngClass]="'moeda'">
                        {{ limite?.valorDisponivel || 0 | bnMask:'MOEDA' }}
                    </td>
                    <td *ngIf="temMensagem(limite)" class="text-end text-danger">
                        {{ limite?.mensagem }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>